// extracted by mini-css-extract-plugin
export default {"container":"dashboard-page_container__qTlF6","content":"dashboard-page_content__AZ09w","main":"dashboard-page_main__cN+WA"};